/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DeleteReferralRecipientConfig200ResponseData } from './DeleteReferralRecipientConfig200ResponseData';
import {
    DeleteReferralRecipientConfig200ResponseDataFromJSON,
    DeleteReferralRecipientConfig200ResponseDataFromJSONTyped,
    DeleteReferralRecipientConfig200ResponseDataToJSON,
} from './DeleteReferralRecipientConfig200ResponseData';

/**
 * 
 * @export
 * @interface DeleteReferralRecipientConfig200Response
 */
export interface DeleteReferralRecipientConfig200Response {
    /**
     * 
     * @type {DeleteReferralRecipientConfig200ResponseData}
     * @memberof DeleteReferralRecipientConfig200Response
     */
    data?: DeleteReferralRecipientConfig200ResponseData;
}

/**
 * Check if a given object implements the DeleteReferralRecipientConfig200Response interface.
 */
export function instanceOfDeleteReferralRecipientConfig200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DeleteReferralRecipientConfig200ResponseFromJSON(json: any): DeleteReferralRecipientConfig200Response {
    return DeleteReferralRecipientConfig200ResponseFromJSONTyped(json, false);
}

export function DeleteReferralRecipientConfig200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteReferralRecipientConfig200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : DeleteReferralRecipientConfig200ResponseDataFromJSON(json['data']),
    };
}

export function DeleteReferralRecipientConfig200ResponseToJSON(value?: DeleteReferralRecipientConfig200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': DeleteReferralRecipientConfig200ResponseDataToJSON(value.data),
    };
}

